module.exports = __webpack_public_path__ + "static/media/fullscreenquad.c04f0fb5.vert";